export enum RouteEnum {
  Login = '/login',
  SignIn = '/signin-oidc',
  SignOut = '/signout-oidc',
}
